import React, { Component } from "react";
import ReactDOM from "react-dom";
import Popup from "../components/common/Popup";
import {
    DKLabel,
    showToast,
    TOAST_TYPE,
    DKButton,
    DKIcons,
    DKInput,
    INPUT_VIEW_DIRECTION,
    showLoader,
    removeLoader,
    DKLine,
    DKIcon
} from "deskera-ui-library";
import InputLabel from '../SharedComponents/InputLabel/InputLabel';
import { FORM_ELEMENTS, PAYROLL_FIELD_KEY_NAMES } from "../constants/Enums";
import Select from 'react-select';
import Table from "../../src/services/table";
import Utility,{ deepClone } from "../utility/Utility";
import ShowProcessData from "../components/common/ShowProcessData";
import PayrollService from "../services/PayrollService";
import EmployeeListService from "../services/EmployeeListService";
import { CONSTANTS, ERRORS_COMPONENTS, INPUT_TYPE, INVALID_FIELD_TO_ID_MAP, IN_COMPONENT_MAX_LIMIT } from "../constants/Constant";
import { getTotalWorkingDaysBetweenDays, getVariableAmountByAmount, isBenefitEnabled, isComponentFormulaConfiguration, isIndiaCompliance, isUSCompliance, scrollToError } from "../managers/common/CommonUtil";
import TenantManager from "../managers/TenantManager";
import FormatCurrencyService from "../services/FormatCurrencyService";
import { TENANT, TenantService } from "../managers/TenantManagerService";
import { COUNTRY } from "../constants/CountryConstant";
import { Contribution, getUSTaxContribution } from "../components/compliance/us/ConstantsUS";
import FormatCurrency from "./FormatCurrency";
import ApiConstants from "../constants/ApiConstants";
import moment from "moment";
import { PaymentMethods, USPaymentMethods } from "../components/add-employee/steps/Employee";
import i18next from "i18next";
import PaymentMethod from "../components/payroll/PaymentMethod";
import { Store } from "../Redux/Store";
import ic_info_message from "../assets/icons/ic_info_gray01.png";

export interface IAddNewRecordPopUpProps {
    tableName: string;
    recordId?: string;
    id: string;
    onSave?: (data: any) => void;
    onClose?: () => void;
    defaultValues: any;
    displayName: string;
    isCustomForm: boolean;
    inputData: any;
    payrollData?: any
}
export interface IAddNewRecordPopUpState {
    employeePayrollsData: {};
    isAddComponentPayroll: boolean
    isAddBenefitsPayroll: boolean
    isEffectiveSalaryBetweenMonth: boolean
}

class EditPayrollPopUp extends Component<
    IAddNewRecordPopUpProps,
    IAddNewRecordPopUpState
> {

    // formData = {}

    componentData = []

    benefitData = []

    componentDropDown = {}

    benefitDropDown = {}

    componentAmount:any = "0"

    employeeBefitAmt = 0

    employerBefitAmt = 0

    isInvalidForm = false

    invalidFiledArray = []

    payrunid = ""

    addedComponent = {
        'name': "",
        'type': "",
        'amount': 0,
        'amount1': 0,
        'compObj': {},
    }


    addedBenefit = {
        'name': "",
        'type': "",
        'amount': 0,
        'amount1': 0,
        'benefitObj': {}
    }

    filed = {
        'lop': false,
        'overtimeRate1': false,
        'overtimeAmount1': false,
        'overtimeRate2': false,
        'overtimeAmount2': false,
        'basicSalary': false,


    }

    overTime1 = {
        amount: 0,
        rate: 1.5,
        value: 0
    };
    overTime2 = {
        amount: 0,
        rate: 2.5,
        value: 0
    };

    employeePayrollsData = {}
    allEmployeePayrollData = {}
    isIndiaTaxEnabled = isIndiaCompliance();
    userDetails;
    isInValidBasic = false;
    inValidComp = false;
    totCompanyDays = 0;
    isUSCompliance = TenantService.get(TENANT.COUNTRY_CODE) === COUNTRY.US;
    taxContribution: Contribution;
    isContractor: boolean;
    isContractorPayFixed : boolean;
    totalEffectiveWorkingDays = {
        before:0,
        after:0
    }
    effectiveCompensation = {}
    paymentMethod = isUSCompliance() ? USPaymentMethods : PaymentMethods;
    canValidatePaymentDetail = false;
    child;
    basicSalaryTooltip = null;
    basicPayrunErrorMessage = null;
    totalComponent = 0;
    isValidAmountForNewComponent = true;
    constructor(props) {
        super(props)
        this.employeePayrollsData = deepClone(this.props.inputData.data);
        this.employeePayrollsData['components'] = this.employeePayrollsData['components'] || []
        this.allEmployeePayrollData = deepClone(this.props.inputData.employeePayrollsData);
        this.isContractor = this.props.inputData.isContractor;
        this.isContractorPayFixed = this.employeePayrollsData && this.employeePayrollsData["compensationPeriod"] === "fixed";
        this.totCompanyDays = this.props.inputData.totCompanyDays
        this.state = {
            employeePayrollsData: this.employeePayrollsData,
            isAddComponentPayroll: false,
            isAddBenefitsPayroll: false,
            isEffectiveSalaryBetweenMonth: (this.employeePayrollsData['basicPayrun'] == this.employeePayrollsData['compensation'] && this.employeePayrollsData['effectiveCompensations']) ? true:false
        };
        if(this.employeePayrollsData['basicPayrun'] == this.employeePayrollsData['compensation'] && this.employeePayrollsData['effectiveCompensations']) {
            this.calculateDaysOff()
            this.isEffectiveSalaryBetween()
            
        }
        if (this.props.inputData.tenantComponents['components'] && this.props.inputData.tenantComponents['components'].length > 0) {
            this.componentData = this.props.inputData.tenantComponents['components']
        }

        if (this.props.inputData.tenantBenefits['benefits'] && this.props.inputData.tenantBenefits['benefits'].length > 0) {
            this.benefitData = this.props.inputData.tenantBenefits['benefits']
        }

        this.payrunid = this.props.inputData.payrunId


        this.getUserDetails(this.employeePayrollsData['userId']);

        if (this.isUSCompliance) {
            this.taxContribution = getUSTaxContribution(this.employeePayrollsData);
        }
        if(Utility.isEmpty(this.employeePayrollsData['paymentMethod'])){
            this.invalidFiledArray.push('paymentMethod')
        }
        this.child = React.createRef();
    }

    calculateDaysOff() {
        let index = this.employeePayrollsData['effectiveCompensations'].findIndex(r => r.isVisible)
        if (index != -1) {

            this.effectiveCompensation = this.employeePayrollsData['effectiveCompensations'][index];
            if (this.effectiveCompensation && this.effectiveCompensation['effectiveDate']) {
                let payrunStart = moment(this.allEmployeePayrollData['workPeriod']?.from, "MM/DD/YYYY").format("YYYY-MM-DD")
                let payrunEnd = moment(this.allEmployeePayrollData['workPeriod']?.to, "MM/DD/YYYY").format("YYYY-MM-DD")
                let isNotEffectiveTill = moment(this.effectiveCompensation['effectiveDate'], 'YYYY-MM-DD').subtract(1, 'days').format("YYYY-MM-DD");
                let beforeCompWorkingDay = getTotalWorkingDaysBetweenDays(payrunStart, isNotEffectiveTill, TenantService.get(TENANT.TENANT_WORK_WEEK));
                let afterCompWorkingDay = getTotalWorkingDaysBetweenDays(this.effectiveCompensation['effectiveDate'], payrunEnd, TenantService.get(TENANT.TENANT_WORK_WEEK));
                this.totalEffectiveWorkingDays = {
                    before: beforeCompWorkingDay,
                    after: afterCompWorkingDay
                }
            }
        }
    }

    isEffectiveSalaryBetween() {
       let daysOff = parseFloat( this.employeePayrollsData['daysOff'])
        if(this.employeePayrollsData['daysOffBefore'] == 0 && this.employeePayrollsData['daysOffAfter'] == 0 && daysOff != 0)  {
            this.employeePayrollsData['daysOffBefore'] = daysOff;
        }
        if(this.totalEffectiveWorkingDays.before < this.employeePayrollsData['daysOffBefore']) {
            this.employeePayrollsData['daysOffBefore'] = this.totalEffectiveWorkingDays.before;
            this.employeePayrollsData['daysOffAfter'] = daysOff - this.totalEffectiveWorkingDays['before'];
        }
    }
    getUserDetails(userId) {
        EmployeeListService.getEmployeeDetailsDefault(userId)
        .then(res=>{
            
            this.userDetails = res['user'];
            this.isContractor = this.userDetails['type'] === CONSTANTS.CONTRACTOR;
            this.getComponents()
            this.getbenefits()
        },error=>{
            this.getComponents()
            this.getbenefits()
        })
    }
    onOTChange = (value, overtime, type, index) => {
        let updateOvertime = {}
        this.formValidation(type.concat(index), value)
        if (value === "") {
            value = " "
        }
        const hourlyPay = this.employeePayrollsData && (this.employeePayrollsData['otPayRate'] ? this.employeePayrollsData['otPayRate'] : ((this.employeePayrollsData['hourlyPay'] ? this.employeePayrollsData['hourlyPay'] : 0)))  ;
        switch (type) {
            case "rate":
                updateOvertime = {
                    rate: value,
                    value: overtime['value'],
                    amount: value * overtime['value'] * hourlyPay,
                }
                break;
            case "amount":
                updateOvertime = {
                    rate: overtime['rate'],
                    value: value,
                    amount: overtime['rate'] * value * hourlyPay,
                }
                break
        }

        if (this.employeePayrollsData['overtime'] && this.employeePayrollsData['overtime'].length > 0) {
            this.employeePayrollsData['overtime'][index] = updateOvertime
        } else {
            if (index === 0) {
                this.employeePayrollsData['overtime'] = [updateOvertime, this.overTime2]
            } else {
                this.employeePayrollsData['overtime'] = [this.overTime1, updateOvertime]
            }
        } this.setState({
            employeePayrollsData: this.employeePayrollsData,
        });
    }

    getOverTime = () => {
        let overtime;

        if (this.employeePayrollsData['overtime']) {
            overtime = this.employeePayrollsData['overtime'].map((overtime, index) => {
                return (
                    <div className="mb-l">
                        <div className="" style={{ display: 'flex' }}>
                            <div className="width-80 mb-xs">
                                <span className=" width-80">Rate</span>
                            </div>
                            <div className="width-80 mb-xs">
                                <span>Value</span>
                            </div>
                            <div className="width-80 mb-xs">
                                <span className="mt-xxl">Amount</span>
                            </div>
                        </div>
                        <div className="parent-width pb-m" style={{ display: 'flex' }}>
                            <div className="width-80 mr-m rate">
                                <DKInput type="number" canValidate={true} direction={INPUT_VIEW_DIRECTION.VERTICAL} className="mr-l width-80" value={overtime.rate} onChange={(value) => this.onOTChange(value, overtime, "rate", index)} />
                            </div>
                            <div className="width-80 mr-m amount">
                                <DKInput type="number" canValidate={true} direction={INPUT_VIEW_DIRECTION.VERTICAL} className="mr-L width-80" value={overtime.value} onChange={(value) => this.onOTChange(value, overtime, "amount", index)} />
                            </div>
                            <div className="width-80 align-self-center">
                                <span className=" fw-m">{FormatCurrencyService.format(overtime.amount)}</span>
                            </div>
                        </div>
                    </div>
                )
            })
        } else {
            return (
                <div className="mt-s">
                    <div className="" style={{ display: 'flex' }}>
                        <div className="width-80 mb-xs"><span className=" width-80">Rate</span></div>
                        <div className="width-80 mb-xs"><span>Value</span></div>
                        <div className="width-80 mb-xs"><span className="mt-xxl">Amount</span></div>
                    </div>
                    <div className="parent-width pb-m" style={{ display: 'flex' }}>
                        <div className="width-80 mr-m rate"><DKInput type="number" canValidate={true} direction={INPUT_VIEW_DIRECTION.VERTICAL} className="mr-l width-80" value={1.5} onChange={(value) => this.onOTChange(value, this.overTime1, "rate", 0)} /></div>
                        <div className="width-80 mr-m amount"><DKInput type="number" canValidate={true} direction={INPUT_VIEW_DIRECTION.VERTICAL} className="mr-L width-80" value={0} onChange={(value) => this.onOTChange(value, this.overTime1, "amount", 0)} /></div>
                        <div className="width-80 align-self-center"><span className=" fw-m">{FormatCurrencyService.format(0)}</span></div>
                    </div>

                    <div className="mt-s mt-l" style={{ display: 'flex' }}>
                        <div className="width-80 mb-xs"><span className=" width-80">Rate</span></div>
                        <div className="width-80 mb-xs"><span>Value</span></div>
                        <div className="width-80 mb-xs"><span className="mt-xxl">Amount</span></div>
                    </div>
                    <div className="parent-width pb-m" style={{ display: 'flex' }}>
                        <div className="width-80 mr-m rate1"><DKInput type="number" canValidate={true} direction={INPUT_VIEW_DIRECTION.VERTICAL} className="mr-l width-80" value={2.5} onChange={(event) => this.onOTChange(event, this.overTime2, "rate", 1)}/></div>
                        <div className="width-80 mr-m amount1"><DKInput type="number" canValidate={true} direction={INPUT_VIEW_DIRECTION.VERTICAL} className="mr-L width-80" value={0} onChange={(event) => this.onOTChange(event, this.overTime2, "amount", 1)} /></div>
                        <div className="width-80 align-self-center"><span className=" fw-m">{FormatCurrencyService.format(0)}</span></div>
                    </div>
                </div>
            )
        }

        return overtime
    }

    deleteComponent = (index) => {
        this.employeePayrollsData['components'].splice(index, 1);
        this.getComponents()
        this.calculateComponentAmount()
        this.setState({
            employeePayrollsData: this.employeePayrollsData,
        });
    }

    deleteBenefit = (index) => {
        this.employeePayrollsData['benefitsMeta'].splice(index, 1);
        this.getbenefits()

        this.setState({
            employeePayrollsData: this.employeePayrollsData,
        });
    }

    getComponentObj = () => {
        let componentDataObj = []
        if (this.employeePayrollsData['components'] && this.employeePayrollsData['components'].length > 0) {
            {
                this.employeePayrollsData['components'].forEach((comp, index) => {
                    let compD = this.componentData.filter(res=>(res.id == comp.componentId))
                    if(compD && compD.length > 0) {
                        let componentObj = {
                            'name': comp.name,
                            'type': comp.type,
                            'amount1': comp.amount,
                            'defaultComponent': compD[0].defaultComponent
                        }
                        componentDataObj.push(componentObj)
                    }
                });
            }
        }
        return componentDataObj
    }

    getBenefitObj = () => {
        let benefittData = []
        if (this.employeePayrollsData['benefitsMeta'] && this.employeePayrollsData['benefitsMeta'].length > 0) {
            {
                this.employeePayrollsData['benefitsMeta'].forEach((comp, index) => {
                    let selectedBenefit = this.benefitData.filter(b => b.benefitId == comp.benefitId)
                    let componentObj = {
                        'name': comp.name,
                        'type': 'Benefit',
                        'amount': comp.employeeDeductionAmount,
                        'amount1': comp.employerDeductionAmount,
                        'empType' : selectedBenefit.length > 0 ? selectedBenefit[0].employeeDeductionType : CONSTANTS.EMPTY_STRING,
                        'emprType' : selectedBenefit.length > 0 ? selectedBenefit[0].employerDeductionType : CONSTANTS.EMPTY_STRING
                    }
                    benefittData.push(componentObj)
                });
            }
        }
        return benefittData
    }


    getComponents() {
        this.componentDropDown = {
            key: PAYROLL_FIELD_KEY_NAMES.COMPONENTS,
            hidden: false,
            value: { label: '', value: '' },
            selectionType: 'single',
            type: FORM_ELEMENTS.DROPDOWN,
            defaultValue: {},
            isMandatory: false,
            options: [],
        }
        if (this.componentData.length > 0) {
            this.componentData.forEach((comp, index) => {
                if (!this.isContractor && (comp['isForAllEmployee'] || (comp['employees'] && comp['employees'].includes(this.employeePayrollsData['userId']))) && comp['isActive'] && !this.isComponentAlreadyExist(comp) && comp['subType'] !== "basic_salary" && comp['subType'] !== "sales_commission" && comp['name'] != CONSTANTS.FIXED_ALLOWANCE) {
                    if (!this.componentDropDown["defaultValue"]["label"]) {
                        this.componentDropDown["defaultValue"] = {
                            'label': comp['name'],
                            'value': comp,
                        }
                        this.addedComponent.name = comp['name']
                        this.addedComponent.type = comp['type']
                        this.addedComponent.compObj = comp
                    }
                    var componentOptions = {
                        'label': comp['name'],
                        'value': comp,
                        'isdisabled': false,
                    }
                    this.componentDropDown['options'].push(componentOptions)
                    if(comp.isVariable) {
                        let obj= {
                            value: comp
                        }
                        this.componentAmount = this.componentAmoutCal(obj)
                    } 
                    if(comp['isFormula'] && comp['formula'] && index ==0) {
                        this.addedComponent.amount = this.getAmountFromFormula(comp);
                        this.componentAmount = this.addedComponent.amount;
                    } 
                } else if (this.isContractor && !comp["isVariable"] && (comp['isForAllEmployee'] || (comp['employees'] && comp['employees'].includes(this.employeePayrollsData['userId']))) && comp['isActive'] && !this.isComponentAlreadyExist(comp) && comp['subType'] !== "basic_salary" && comp['subType'] !== "sales_commission" && comp['name'] != CONSTANTS.FIXED_ALLOWANCE) {
                    if (!this.componentDropDown["defaultValue"]["label"]) {
                        this.componentDropDown["defaultValue"] = {
                            'label': comp['name'],
                            'value': comp,
                        }
                        this.addedComponent.name = comp['name']
                        this.addedComponent.type = comp['type']
                        this.addedComponent.compObj = comp
                    }
                    var componentOptions = {
                        'label': comp['name'],
                        'value': comp,
                        'isdisabled': false,
                    }
                    this.componentDropDown['options'].push(componentOptions)
                    if(comp.isVariable) {
                        let obj= {
                            value: comp
                        }
                        this.componentAmount = this.componentAmoutCal(obj)
                    } else {
                        this.componentAmount = 0;
                    }
                }
            })

        }
    }

    isComponentAlreadyExist(component) {
        if (this.employeePayrollsData["components"] && this.employeePayrollsData["components"].length > 0) {
            for (let i = 0; i < this.employeePayrollsData["components"].length; i++) {
                if (this.employeePayrollsData["components"][i].componentId === component.id) {
                    return true
                }
            }
        }
        return false
    }

    getbenefits() {
        this.benefitDropDown = {
            key: PAYROLL_FIELD_KEY_NAMES.BENEFIT,
            hidden: false,
            value: { label: '', value: '' },
            selectionType: 'single',
            type: FORM_ELEMENTS.DROPDOWN,
            isMandatory: false,
            defaultValue: {},
            options: [],
        }
        if (this.benefitData.length > 0) {
            this.benefitData.forEach(benefit => {
                if ((benefit['isForAllEmployees'] || this.benefitValidForUser(this.employeePayrollsData['userId'], benefit)) && benefit["isActive"] && !this.isBenefitAlreadyExist(benefit)) {

                    if (!this.benefitDropDown["defaultValue"]["label"]) {
                        this.benefitDropDown["defaultValue"] = {
                            'label': benefit['name'],
                            'value': benefit
                        }
                        this.addedBenefit.name = benefit['name']
                        this.addedBenefit.type = "Benefit"
                        this.addedBenefit.benefitObj = benefit
                        this.setBenefitAmount(benefit)

                    }
                    var benefitOptions = {
                        'label': benefit['name'],
                        'value': benefit,
                        'isdisabled': true
                    }
                    this.benefitDropDown['options'].push(benefitOptions)
                }
            })
        }
    }

    isBenefitAlreadyExist(benefit) {
        if (this.employeePayrollsData["benefitsMeta"] && this.employeePayrollsData["benefitsMeta"].length > 0) {
            for (let i = 0; i < this.employeePayrollsData["benefitsMeta"].length; i++) {
                if (this.employeePayrollsData["benefitsMeta"][i].benefitId === benefit.benefitId) {
                    return true
                }
            }
        }
        return false
    }

    benefitValidForUser = (userId, benefits) => {

        if (benefits.users && benefits.users.length > 0) {

            for (let i = 0; i < benefits.users.length; i++) {
                if (benefits.users[i].userId === userId) {
                    return true
                }
            }
        }

        return false
    }

    onChangeOfComponent = (event) => {

        this.addedComponent.name = event.value.name
        this.addedComponent.type = event.value.type
        this.addedComponent.compObj = event.value
        this.componentAmount = this.componentAmoutCal(event);
        this.addedComponent.amount = this.componentAmoutCal(event);
        this.isValidAmount(this.componentAmount)
        this.setState({
            employeePayrollsData: deepClone(this.employeePayrollsData),
        });
    }
    componentAmoutCal(event){
        let calculatedAmount = 0;
        let Amount = this.isIndiaTaxEnabled ? this.state.employeePayrollsData['basicPayrun'] : this.userDetails.compensation
        if(this.addedComponent.compObj && this.addedComponent.compObj['isVariable']) {
            let defaultValue = 0;
            switch(event.value.componentConfig.configureAmountBasis) {
                case 'percentageOfBasicSalary':
                    defaultValue = Amount;
                    break;
                case 'percentageOfSpecificComponent':
                    let components = this.userDetails.components ? this.userDetails.components: [];
                    let compInd = components.findIndex(component => (component.componentId == event.value.componentConfig.basisComponentId))
                    if(compInd != -1){
                        defaultValue = components[compInd].amount
                    } else {
                        defaultValue = 0;
                    }
                    break;
                case 'amountPerDay':
                    defaultValue = 0;
                    break;
                case 'percentageOfCTC':
                    defaultValue=0
                    break;
            }

            let tenant = TenantManager.getPeopleTenantData();
            let compensation = this.isIndiaTaxEnabled ? ((this.userDetails && this.userDetails.ctc)?this.userDetails.ctc:0 ) : this.employeePayrollsData['compensation']
            let amount = getVariableAmountByAmount(
                event.value,// component
                this.employeePayrollsData['compensationPeriod'],//compensationPeriod
                compensation,//compensation
                tenant['tenant'].workWeekDetails,// workweek
                this.componentData,//all component
                defaultValue,//  amount
                this.userDetails)

                calculatedAmount = !isNaN(parseFloat(amount.toFixed(2)))? parseFloat(amount.toFixed(2)) : 0;
                calculatedAmount = !isNaN(parseFloat(amount.toFixed(2)))? parseFloat(amount.toFixed(2)) : 0;
        } else if(event?.value?.isFormula) {
            calculatedAmount = this.getAmountFromFormula(event.value)
        } else {
            calculatedAmount = 0;
            calculatedAmount = 0;
        }
        this.calculateComponentAmount()
        if(this.addedComponent.compObj['isFormula'] && this.basicPayrunErrorMessage) {
            showToast(this.basicPayrunErrorMessage,TOAST_TYPE.WARNING)
            return
        } 
        return calculatedAmount;
    }

    /*
    Calculate Component Amount Formula configuration
    */
   getAmountFromFormula = (selectedValue) => {
    let finalAmount = 0;
    if(isComponentFormulaConfiguration() && (!Utility.isEmpty(selectedValue.formula) && !Utility.isEmpty(selectedValue.formulaConfig))) {
      let formulaConfig = deepClone(selectedValue.formulaConfig);
      let formulaString = deepClone(selectedValue.formula);
      formulaConfig.forEach(config=>{
        // check for basic 
        let isBasic = this.componentData.some(c=>(c.id===config.componentId && c.subType === 'basic_salary'))
        if(isBasic) {
            config['percentageCalculation'] = this.getPercentage(this.state.employeePayrollsData['basicPayrun'], config.percentage)
        } else if(config.componentId == 'ctc') {
            let compensation = this.getCompensation(this.employeePayrollsData) ;
            if(this.isIndiaTaxEnabled) {
                compensation = this.getCalculatedCompensation(this.employeePayrollsData) ;
            }
            config['percentageCalculation'] = this.getPercentage(compensation, config.percentage);
        } else {
            let component = this.employeePayrollsData['components'].find(c=>c.componentId == config.componentId)
            if(component) {
                config['percentageCalculation'] = this.getPercentage(component.amount, config.percentage);
            } else {
                config['percentageCalculation'] = 0;
            }
        }
        formulaString = formulaString?.replace(config.index,config['percentageCalculation']);
      })
      try{
        finalAmount = eval(formulaString)
        finalAmount = isFinite(finalAmount) ? finalAmount : 0;
        finalAmount.toFixed(2)
      } catch(e) {
        finalAmount = 0;
      }
    } else {
      finalAmount = selectedValue.amount ? selectedValue.amount.toFixed(2) : 0;
    }
    return parseFloat(finalAmount.toFixed(2));
  }
  getPercentage =(amount,percentage)=>{
    return amount ? ((parseFloat(amount))/100)*percentage :0
  }
    onBenefitSelect = (event) => {
        this.addedBenefit.name = event.value.name
        this.addedBenefit.type = "Benefit"
        this.addedBenefit.benefitObj = event.value
        this.setBenefitAmount(event.value)
        this.setState({
            employeePayrollsData: this.employeePayrollsData,
        });
    }

    setBenefitAmount = (obj) => {

        this.employeeBefitAmt = obj.employeeDeductionAmount
        this.employerBefitAmt = obj.employerDeductionAmount

    }

    onCompountAmountAdded = (value) => {
        this.formValidation("compAmt", value)
        if (value === "") {
            value = " "
        }
        this.addedComponent.amount = value
        this.componentAmount = value
        this.setState({
            employeePayrollsData: this.employeePayrollsData,
        });

    }

    onLOPChanged = (event) => {
        this.formValidation("lop", event)
        if (event === "") {
            event = " "
        }
        if(this.totCompanyDays < event){
            this.formValidation("lopGreater", event)
            this.invalidFiledArray.push("lopGreater")
        } else {
            const index = this.invalidFiledArray.indexOf("lopGreater");
            if (index > -1) {
                this.invalidFiledArray.splice(index, 1);
            }
        }
        let lopAmount = this.employeePayrollsData['basicPayForDay'] * event
        let basicPayrun = isIndiaCompliance() ? this.employeePayrollsData['ctc'] : this.employeePayrollsData['basicPayrun']
        if(!(this.employeePayrollsData['basicPayrun'] == this.employeePayrollsData['compensation'] && this.employeePayrollsData['effectiveCompensations']) ) {
            lopAmount = (event== 0 || event == " " || event == "") ? 0 : (parseFloat(basicPayrun)/this.totCompanyDays )* event
        }
        
        this.employeePayrollsData['daysOff'] = event
        this.employeePayrollsData['lossOfPay'] = lopAmount
        this.setState({
            employeePayrollsData: this.employeePayrollsData,
        });
        if((this.employeePayrollsData['basicPayrun'] == this.employeePayrollsData['compensation'] && this.employeePayrollsData['effectiveCompensations']) ) {
            this.isEffectiveSalaryBetween()
        }
    }

    onEffectiveLOPChanged = (event, isBefore) => { // validation
        if (event === "" ) {
            event = 0
        }
        if(isBefore) {
            this.employeePayrollsData['daysOffBefore'] = parseFloat(event);
            this.isEffectiveValid('lopBeforeGreater',this.totalEffectiveWorkingDays.before,this.employeePayrollsData['daysOffBefore'])
        } else {
            this.employeePayrollsData['daysOffAfter'] = parseFloat(event);
            this.isEffectiveValid('lopAfterGreater',this.totalEffectiveWorkingDays.after,this.employeePayrollsData['daysOffAfter'])
        }
        
        this.employeePayrollsData['lossOfPay'] = this.getLOPAmount('daysOffAfter','basicAfter') + this.getLOPAmount('daysOffBefore','basicBefore')
        this.employeePayrollsData['daysOff'] = this.employeePayrollsData['daysOffBefore'] + this.employeePayrollsData['daysOffAfter']
        this.setState({
            employeePayrollsData: this.employeePayrollsData,
        });
    }
    isEffectiveValid(field, totalWorkingDays, event) {
         if(totalWorkingDays < event){
            this.formValidation(field, event)
            this.invalidFiledArray.push(field)
        } else {
            const index = this.invalidFiledArray.indexOf(field);
            if (index > -1) {
                this.invalidFiledArray.splice(index, 1);
            }
        }
    }
    getLOPAmount(days, basic) {
        return this.state.employeePayrollsData[days] * this.state.employeePayrollsData[basic]
    }

    formValidation = (key, value) => {
        if (value === "") {
            this.invalidFiledArray.push(key)
        } else {
            const index = this.invalidFiledArray.indexOf(key);
            if (index > -1) {
                this.invalidFiledArray.splice(index, 1);
            }
        }

    }

    isFieldInvalid = (key) => {
        const index = this.invalidFiledArray.indexOf(key);
        if (index > -1) {
            return true
        }
        return false
    }

    onAddComponent = (event) => {

        if (this.isFieldInvalid("compAmt")) {
            showToast("Inavlid field", TOAST_TYPE.FAILURE);
            return
        }

        if (!this.addedComponent.compObj['id']) {
            showToast("Please select the earnings and deductions", TOAST_TYPE.WARNING);
            return
        }

        let componentKeys = ["componentId", "employeeId", "name", "type", "amount", "status", "isVariable", "componentConfig", "frequency", "isHidden", "subType", "defaultComponent", "includeInCTC"]

        let componentObj = {}

        componentKeys.forEach(key => {
            componentObj[key] = this.addedComponent.compObj[key] !== undefined ? this.addedComponent.compObj[key] : ""
        })

        componentObj["componentId"] = this.addedComponent.compObj['id']
        componentObj["amount"] = this.addedComponent.amount
        componentObj["status"] = "modified"

        let afterAddingComponent = deepClone(this.employeePayrollsData)
        if (this.employeePayrollsData['components']) {
            this.employeePayrollsData['components'].push(componentObj)
        } else {
            this.employeePayrollsData['components'] = [componentObj]
        }
        this.calculateComponentAmount()
        this.employeePayrollsData['components'].forEach((element, index) => {
            this.employeePayrollsData['components'][index]['employeeId'] = this.employeePayrollsData["employeeId"]
        });

        this.addedComponent = {
            'name': "",
            'type': "",
            'amount': 0,
            'amount1': 0,
            'compObj': {},
        }

        this.getComponents()
        this.componentAmount = "0"
        this.getComponents()
        this.setState({
            isAddComponentPayroll: false,
            employeePayrollsData: this.employeePayrollsData,
        });
    }
    calculateComponentAmount() {
        if(this.isIndiaTaxEnabled) {
            let compensation = this.getCalculatedCompensation(this.employeePayrollsData);
            let basic = this.employeePayrollsData['basicPayrun'];
            let components = this.employeePayrollsData['components'];
            let hraIndex = components.findIndex(res=>(res.name=='HRA'))
            if(hraIndex != -1) {
                let hraPercentage = components[hraIndex].componentConfig?.componentPercent;

                this.employeePayrollsData['components'][hraIndex].amount = (parseFloat(basic) * hraPercentage) / 100;
            }
            let count = 0;
            let fixedAllowanceIndex = -1;
            // update Amount For Formula Component
            this.employeePayrollsData['components'].forEach(comp=>{
                if(!Utility.isEmpty(comp['formula'])) {
                    comp['amount'] = this.getAmountFromFormula(comp)
                }
            })
            // update Amount For Formula Component
            this.employeePayrollsData['components'].forEach((element, index) => {
                let compD = this.componentData.filter(res=>(res.id == element.componentId))
                if (
                  element.type == "EARNING" &&
                  compD &&
                  Array.isArray(compD) &&
                  compD.length > 0 &&
                  compD[0].includeInCTC
                ) {
                  if (element.name != "Fixed Allowance") {
                    count = count + parseFloat(element.amount);
                  } else {
                    fixedAllowanceIndex = index;
                  }
                }
            })
            count = count + parseFloat(basic)
            this.totalComponent = count;
            let fixedAllowanceAmount = (compensation) - count;
            if(fixedAllowanceIndex != -1 ) {
                // Do Nothing - PEOP-296;
                // Note: Don't change fixed allowance on UI in case of unpaid days are greater than 0
                if(isIndiaCompliance() && parseInt(this.employeePayrollsData['daysOff']) === 0) {
                    this.employeePayrollsData['components'][fixedAllowanceIndex].amount = fixedAllowanceAmount;
                }

                if(isIndiaCompliance() && fixedAllowanceAmount < 0) {
                    this.basicSalaryTooltip = i18next.t('TOTAL_AMOUNT_EXCEEDS_CTC');
                    this.basicPayrunErrorMessage = i18next.t('TOTAL_AMOUNT_EXCEEDS_CTC_1');
                } else {
                    this.basicSalaryTooltip = null;
                    this.basicPayrunErrorMessage = null;
                }
            }
        }
    }
    onAddBenefit = () => {

        if (this.isFieldInvalid("employeeBenefit") || this.isFieldInvalid("employerBenefit")) {
            showToast("Inavlid field", TOAST_TYPE.FAILURE);
            return
        }

        if (!this.addedBenefit.benefitObj["benefitId"]) {
            showToast("No benefit to add", TOAST_TYPE.WARNING);
            return
        }
        let benefitObj = {}

        benefitObj["employeeDeductionAmount"] = this.employeeBefitAmt
        benefitObj["employeeDeductionType"] = this.addedBenefit.benefitObj["employeeDeductionType"]
        benefitObj["employerDeductionAmount"] = this.employerBefitAmt
        benefitObj["employerDeductionType"] = this.addedBenefit.benefitObj["employerDeductionType"]


        benefitObj["benefitId"] = this.addedBenefit.benefitObj["benefitId"]
        benefitObj["name"] = this.addedBenefit.benefitObj["name"]

        if (this.employeePayrollsData['benefitsMeta']) {
            this.employeePayrollsData['benefitsMeta'].push(benefitObj)
        } else {
            this.employeePayrollsData['benefitsMeta'] = [benefitObj]
        }

        this.addedBenefit = {
            'name': "",
            'type': "",
            'amount': 0,
            'amount1': 0,
            'benefitObj': {}
        }
        this.getbenefits()
        this.setState({
            isAddBenefitsPayroll: false,
            employeePayrollsData: this.employeePayrollsData,
        });
    }

    onAddButtonClick = (event, type) => {

        if (type === "Earnings and Deductions") {
            this.setState({
                isAddComponentPayroll: true,
                isAddBenefitsPayroll: false
            });
        } else {
            this.setState({
                isAddComponentPayroll: false,
                isAddBenefitsPayroll: true
            });
        }

    }

    removePopUp = () => {
        ReactDOM.unmountComponentAtNode(document.getElementById(this.props.id));
        document.getElementById(this.props.id)?.remove();
    }

    onClose = () => {
        if (this.props.onClose) this.props.onClose();
        this.removePopUp();
    };


    onEmployeeContributionAmountAdded = (value, type) => {
        this.formValidation(type, value)
        if (value === "") {
            value = 0
        }
        if (type === "employeeBenefit") {
            this.employeeBefitAmt = value
            this.addedComponent.amount = value
        } else {
            this.employerBefitAmt = value
            this.addedComponent.amount1 = value
        }

        this.setState({
            employeePayrollsData: this.employeePayrollsData,
        });
    }

    onBasicPayChanged = (value) => {
        this.formValidation("basicPay", value)

        if (value === "") {
            value = " "
        }
        this.employeePayrollsData["basicPayrun"] = value
        this.getErrorMessage('basicPayrun')
        if(value == this.employeePayrollsData['compensation'] && this.employeePayrollsData['effectiveCompensations']) {
            this.isEffectiveSalaryBetween()
            
            this.setState({
                employeePayrollsData: this.employeePayrollsData,
                isEffectiveSalaryBetweenMonth:true
            })
            
        } else {
            this.employeePayrollsData['daysOffBefore'] = 0
            this.employeePayrollsData['daysOffAfter'] = 0
            if(this.isIndiaTaxEnabled ) {
                let maxCompensation = this.getCalculatedCompensation(this.employeePayrollsData);
                maxCompensation = (maxCompensation * IN_COMPONENT_MAX_LIMIT.basic)/100;
                if(maxCompensation >= parseFloat(this.employeePayrollsData["basicPayrun"])) {
                    this.isInValidBasic = false;
                } else {
                    this.isInValidBasic = true;
                }
            }
            this.employeePayrollsData['lossOfPay'] = ((this.employeePayrollsData['basicPayrun']/ this.totCompanyDays) * this.employeePayrollsData['daysOff'])
            this.calculateComponentAmount()
            this.setState({
                employeePayrollsData: this.employeePayrollsData,
                isEffectiveSalaryBetweenMonth: false
            });
        }
    }

    onRegularHrsChanged = (value) => {
        this.formValidation("hoursWorked", value)

        if (value === "") {
            value = " "
        }
        this.employeePayrollsData["hoursWorked"] = value
        this.setState({
            employeePayrollsData: this.employeePayrollsData,
        });

    }
    onFixedAmountChange = (value) => {
        this.formValidation("contractorFixedAmount", value)

        if (value === "") {
            value = " "
        }
        this.employeePayrollsData["basicPayrun"] = value
        // if(this.isIndiaTaxEnabled ) {
        //     let maxCompensation = this.getCompensation(this.employeePayrollsData);
        //     maxCompensation = (maxCompensation * IN_COMPONENT_MAX_LIMIT.basic)/100;
        //     if(maxCompensation > parseFloat(this.employeePayrollsData["basicPayrun"])) {
        //         this.isInValidBasic = false;
        //     } else {
        //         this.isInValidBasic = true;
        //     }
        // }
        // this.calculateComponentAmount()
        this.setState({
            employeePayrollsData: this.employeePayrollsData,
        });

    }
    onRegularWorkingHoursChange = (value) => {
        this.formValidation("contractorWorkingHours", value)

        if (value === "") {
            value = " "
        }
        this.employeePayrollsData["hoursWorked"] = value
        // if(this.isIndiaTaxEnabled ) {
        //     let maxCompensation = this.getCompensation(this.employeePayrollsData);
        //     maxCompensation = (maxCompensation * IN_COMPONENT_MAX_LIMIT.basic)/100;
        //     if(maxCompensation > parseFloat(this.employeePayrollsData["basicPayrun"])) {
        //         this.isInValidBasic = false;
        //     } else {
        //         this.isInValidBasic = true;
        //     }
        // }
        // this.calculateComponentAmount()
        this.setState({
            employeePayrollsData: this.employeePayrollsData,
        });

    }

    onCancel = () => {
        this.setState({
            isAddComponentPayroll: false,
            isAddBenefitsPayroll: false
        });
    }

    updatePayroll = () => {

        if (this.invalidFiledArray.length > 0) {
            const invalidField = INVALID_FIELD_TO_ID_MAP[this.invalidFiledArray[0]];
            if(!Utility.isEmpty(invalidField)) {
                scrollToError(invalidField);
            }
            this.canValidatePaymentDetail = true;
            this.setState({
                ...this.state
            })
            showToast(i18next.t("PLEASE_FILL_FILED"), TOAST_TYPE.FAILURE);
            return
        }
        if(this.isIndiaTaxEnabled && this.isInValidBasic) {
            showToast(i18next.t("INVALID_FIELD_VALUE"), TOAST_TYPE.FAILURE);
            return
        }
        if(isIndiaCompliance() && this.basicSalaryTooltip) {
            showToast(i18next.t("INVALID_FIELD_VALUE"), TOAST_TYPE.FAILURE);
            return
        }
        if (!this.isContractor) {
            let paymentData = this.child.current.getPaymentDetailFormData();
            if (!paymentData) {
                showToast(i18next.t("PLEASE_FILL_FILED"), TOAST_TYPE.FAILURE);
                return
            }
        this.employeePayrollsData = {...this.employeePayrollsData,...paymentData}
        }
        this.employeePayrollsData["daysOff"] = parseFloat(this.employeePayrollsData["daysOff"])
        this.employeePayrollsData["basicPayrun"] = parseFloat(this.employeePayrollsData["basicPayrun"])

        if (this.employeePayrollsData["overtime"] && this.employeePayrollsData["overtime"].length > 0) {
            this.employeePayrollsData["overtime"].forEach((element, index) => {
                this.employeePayrollsData["overtime"][index].rate = parseFloat(element.rate)
                this.employeePayrollsData["overtime"][index].value = parseFloat(element.value)

            });
        }

        if (this.employeePayrollsData["benefitsMeta"] && this.employeePayrollsData["benefitsMeta"].length > 0) {
            this.employeePayrollsData["benefitsMeta"].forEach((element, index) => {
                this.employeePayrollsData["benefitsMeta"][index].employeeDeductionAmount = parseFloat(element.employeeDeductionAmount)
                this.employeePayrollsData["benefitsMeta"][index].employerDeductionAmount = parseFloat(element.employerDeductionAmount)
            });
        }

        if (this.employeePayrollsData["components"] && this.employeePayrollsData["components"].length > 0) {
            this.employeePayrollsData["components"].forEach((element, index) => {
                this.employeePayrollsData["components"][index].amount = parseFloat(element.amount)
            });
        }

        if(this.isContractor) {
            if(!this.isContractorPayFixed)  {
                this.employeePayrollsData["hoursWorked"] = parseInt(this.employeePayrollsData["hoursWorked"]);
            }
        }
        if(!this.isContractor && this.employeePayrollsData["compensationPeriod"] === CONSTANTS.HOURLY) {
            this.employeePayrollsData["hoursWorked"] = parseInt(this.employeePayrollsData["hoursWorked"])
        }

        this.save({})


    }

    getCompensation = (employeeData) => {
        let compensation = this.isIndiaTaxEnabled && this.userDetails.type != "CONTRACTOR" ? this.userDetails.ctc : employeeData.compensation
        if(employeeData.compensationPeriod === '365') {
          return compensation/12;
        } else {
          return compensation;
        }
      }

    getCalculatedCompensation = (employeeData) => {
        let compensation = this.isIndiaTaxEnabled && this.userDetails.type != "CONTRACTOR" ? employeeData.ctc : employeeData.compensation;
        return compensation;
    }


    save = async (config) => {
        const componentsTemp = this.componentData?this.componentData:[];
        const componentMap = {};
        componentsTemp.forEach((val)=>{
          componentMap[val.id]= val.isUnpaidIncluded;
        });
        
        const employeeComponentData = (this.employeePayrollsData && this.employeePayrollsData["components"])?deepClone(this.employeePayrollsData["components"]):[];
        employeeComponentData.forEach((item)=>{
            if(componentMap.hasOwnProperty(item.componentId)){
              item.isUnpaidIncluded = componentMap[item.componentId];
            }
        });
        this.employeePayrollsData["components"] = employeeComponentData;
        try {

            PayrollService.apiConfig = config;
            showLoader(i18next.t("UPDATE_PAYROLL"));
            Table.upatePayroll(this.employeePayrollsData, this.payrunid).then((data) => {
                showToast("Record updated Successfully", TOAST_TYPE.SUCCESS);
                this.loadPayrollForFirstStep({})
            })
        } catch (err) {
            removeLoader()
            showToast('Error updating payrolls: ', TOAST_TYPE.FAILURE);
        }
    }

    loadPayrollForFirstStep = async (config) => {
        try {
            PayrollService.apiConfig = config;
            await this.props.inputData.fun();
            removeLoader()
            this.onClose()


        } catch (err) {
            console.error('Error loading payrolls: ', err);
        }
    };
    errorMsg = (msg) => {
        return (
            <span className="text-red text-red fs-s ml-s">{msg}</span>
        )
    }

    onPaymentMethodChange = (paymentMethod) => {
        if(!Utility.isEmpty(paymentMethod)) {
            const index = this.invalidFiledArray.indexOf("paymentMethod");
            if (index > -1) {
                this.invalidFiledArray.splice(index, 1);
            }
        }
    }

    getTaxContribution() {
        return Object.entries(this.taxContribution).map(([key, value]) => {
            return (
                <div key={key} className="parent-width">
                    <DKLabel text={`${key === "employee" ? "Employee" : "Employer"} Taxes`} className="fw-m mt-l" />
                    <div className="column justify-content-center align-items-center bg-gray1 border-radius-s mt-s p-l border-box parent-width">
                        <div className="row mb-xs">
                            <div style={{ width: "50%" }}></div>
                            <DKLabel text="Current" className="text-gray text-align-right" style={{ width: "20%" }} />
                            <DKLabel text="Year to date" className="text-gray text-align-right" style={{ width: "30%" }} />
                        </div>
                        <DKLine className="bg-gray3" />
                        
                        {value.map((tax, index) => {
                            return (
                                <>
                                    <div key={index} className="row m-v-m">
                                        <DKLabel text={tax.name} className="fw-m" style={{ width: "50%" }} />
                                        <div style={{ width: "20%" }}>
                                            <FormatCurrency amount={tax.current} className="fw-m text-align-right" />
                                        </div>
                                        <div style={{ width: "30%" }}>
                                            <FormatCurrency amount={tax.yearToDate} className="fw-m text-align-right" />
                                        </div>
                                    </div>
                                    <DKLine className="bg-gray3" />
                                </>
                            )
                        })}
                    </div>
                </div>
            );
        });
    }
    getErrorMessage(field) {
        
        switch(field) {
            case "basicPayrun":
                this.basicPayrunErrorMessage = (isIndiaCompliance() && !Utility.isEmpty(this.state.employeePayrollsData['basicPayrun'])) ? `Basic can be maximum of ${IN_COMPONENT_MAX_LIMIT.basic}% of CTC` : "";
                break;
            default:
                this.basicPayrunErrorMessage = null
        }
        
    }
    getTooltip(txt) {
        return (
            <div className="custom-tooltip position-relative width-auto ">
                <DKIcon
                    src={ic_info_message}
                    className="ml-s ic-s ml-r  cursor-hand "
                    style={{ opacity: 0.4 }}
                />
                <span className={`custom-tooltiptext dk-input-holder border-radius-m 
                                    shadow-m bg-white text-dark-gray border-m 
                                    position-fixed p-m border-box z-index-6 `}>
                    <DKLabel text={txt}/>
                </span>
            </div>
        )
    }
    isValidAmount(value) {
        let isValid = true;
        if(isComponentFormulaConfiguration()) {
            this.addedComponent.amount = this.componentAmount;
            let total = 0;
            if(this.addedComponent.type != "DEDUCTION" && this.addedComponent.compObj['includeInCTC'] && !this.isContractor) {
                total = (this.totalComponent) + (!isNaN(parseFloat(value)) ? parseFloat(value) : 0);
                let fixedAllownance = this.getCompensation(this.employeePayrollsData) - total;
                if(this.isIndiaTaxEnabled) {
                    fixedAllownance = this.getCalculatedCompensation(this.employeePayrollsData) - total;
                }                
                if (fixedAllownance < 0) {
                    isValid = false;
                } else {
                    isValid = true
                }
            }
        }
        this.isValidAmountForNewComponent = isValid
        return isValid
    }
    render() {
        return (
            <>
                <Popup>
                    <div className="row mb-m" style={{ display: "flex" }}>
                        <DKLabel text={`${this.isContractor ? "Edit Contractor Payroll": "Edit Employee Payroll"}`} className="fs-m fw-m align-self-center width-80" />
                        <div className="d-flex m-v-s ">
                            <DKButton
                                title="Cancel"
                                className="g-gray1 border-m"
                                onClick={(event) => {
                                    this.onClose();
                                }}
                            />
                            <DKButton
                                title="Save"
                                className="border-m ml-r bg-app text-white"
                                onClick={() => this.updatePayroll()}
                            />

                        </div>
                    </div>
                    <div className="custom-scroll" style={{height:"100%", overflowY:"auto"}}>
                        <div className="mb-l">
                            <DKInput
                                value={this.state.employeePayrollsData['firstName'] + " " + this.state.employeePayrollsData['lastName']}
                                title={`${this.isContractor ? "Contractor Name" : "Employee Name" }`}
                                showError={false}
                                direction={INPUT_VIEW_DIRECTION.VERTICAL}
                                readOnly={true}
                                onChange={(value) => {
                                    return true
                                }
                                }
                            />
                        </div>
                        {!this.isContractor && (
                            <>
                                {
                                    !this.state.isEffectiveSalaryBetweenMonth &&
                                    (   
                                    <div className="mb-l" style={{ display: "flex" }}>
                                    <div style={{ width: '41%' }} className={`daysOff`}>
                                        <DKInput
                                            value={this.state.employeePayrollsData['daysOff']}
                                            title={"Unpaid Days"}
                                            type="number"
                                            readOnly={isIndiaCompliance() && this.state.employeePayrollsData['compensationPeriod'] === CONSTANTS.HOURLY}
                                            canValidate={true}
                                            errorMessage="<span class='white-space-no-wrap'>Enter a valid unpaid days</span>"
                                            onChange={(event) => this.onLOPChanged(event)}
                                            direction={INPUT_VIEW_DIRECTION.VERTICAL}
                                        />
                                        {this.invalidFiledArray.indexOf("lopGreater") !== -1 && <div>
                                            <DKLabel
                                                className=" pt-s fs-s unselectable text-red"
                                                style={{
                                                    whiteSpace: "nowrap",
                                                }}
                                                text={
                                                    "Unpaid Days should not be more than work period."
                                                }
                                            />
                                        </div>}
                                    </div>
                                    <div className="align-self-center parent-height mt-l ml-xxl" style={{ height: "auto" }}>
                                        <span className="fw-m">{FormatCurrencyService.format(this.state.employeePayrollsData['lossOfPay'])}</span>
                                    </div>

                                </div>
                                )}
                                {
                                    this.state.isEffectiveSalaryBetweenMonth && <>
                                        <div className="mb-l" style={{ display: "flex" }}>
                                            <div style={{ width: '51%' }} className={`daysOffBefore`}>
                                                <DKInput
                                                    value={this.state.employeePayrollsData['daysOffBefore']}
                                                    title={"Unpaid Days Before Effective Date"}
                                                    type="number"
                                                    readOnly={isIndiaCompliance() && this.state.employeePayrollsData['compensationPeriod'] === CONSTANTS.HOURLY}
                                                    canValidate={true}
                                                    errorMessage="<span class='white-space-no-wrap'>Enter a valid unpaid days</span>"
                                                    onChange={(event) => this.onEffectiveLOPChanged(event,true)}
                                                    direction={INPUT_VIEW_DIRECTION.VERTICAL}
                                                />
                                                {this.invalidFiledArray.indexOf("lopBeforeGreater") !== -1 && <div>
                                                    <DKLabel
                                                        className=" pt-s fs-s unselectable text-red"
                                                        style={{
                                                            whiteSpace: "nowrap",
                                                        }}
                                                        text={
                                                            "Unpaid Days should not be more than work period."
                                                        }
                                                    />
                                                </div>}
                                            </div>
                                            <div className="align-self-center parent-height mt-l ml-l" style={{ height: "auto" }}>
                                                <span className="fw-m">{
                                                FormatCurrencyService.format(this.state.employeePayrollsData['daysOffBefore'] * this.state.employeePayrollsData['basicBefore'])
                                                }</span>
                                            </div>

                                        </div>

                                        <div className="mb-l" style={{ display: "flex" }}>
                                            <div style={{ width: '51%' }} className={`daysOffAfter`}>
                                                <DKInput
                                                    value={this.state.employeePayrollsData['daysOffAfter']}
                                                    title={"Unpaid Days After Effective Date"}
                                                    type="number"
                                                    disabled={isIndiaCompliance() && this.state.employeePayrollsData['compensationPeriod'] === CONSTANTS.HOURLY}
                                                    canValidate={true}
                                                    errorMessage="<span class='white-space-no-wrap'>Enter a valid unpaid days</span>"
                                                    onChange={(event) => this.onEffectiveLOPChanged(event,false)}
                                                    direction={INPUT_VIEW_DIRECTION.VERTICAL}
                                                />
                                                {this.invalidFiledArray.indexOf("lopAfterGreater") !== -1 && <div>
                                                    <DKLabel
                                                        className=" pt-s fs-s unselectable text-red"
                                                        style={{
                                                            whiteSpace: "nowrap",
                                                        }}
                                                        text={
                                                            "Unpaid Days should not be more than work period."
                                                        }
                                                    />
                                                </div>}
                                            </div>
                                            <div className="align-self-center parent-height mt-l ml-l" style={{ height: "auto" }}>
                                            <span className="fw-m">{
                                                FormatCurrencyService.format(this.getLOPAmount('daysOffAfter','basicAfter'))
                                                }</span>
                                            </div>

                                        </div>
                                    </>
                                }
                            </>
                        )}

                        {!this.isContractor && this.state.employeePayrollsData['compensationPeriod'] != CONSTANTS.HOURLY && (<div className="mb-l">
                            <DKInput
                                value={this.state.employeePayrollsData['daysWorked']}
                                title="Regular Days (RD)"
                                readOnly={true}
                                direction={INPUT_VIEW_DIRECTION.VERTICAL}

                            />
                        </div>)}
                        {!this.isContractor && this.state.employeePayrollsData['compensationPeriod'] === CONSTANTS.HOURLY && (<div className="mb-l hoursWorked">
                            <DKInput
                                value={this.state.employeePayrollsData['hoursWorked']}
                                title="Regular Hrs (RH)"
                                readOnly={isIndiaCompliance()}
                                direction={INPUT_VIEW_DIRECTION.VERTICAL}
                                type={INPUT_TYPE.NUMBER}
                                onChange={(value) => { this.onRegularHrsChanged(value) }}
                                canValidate={true}
                            />
                        </div>)}
                        {!this.isContractor && (<div className="parent-width mb-l">
                            <DKLabel text="Overtime*" className="fw-m mb-m" />
                            {this.getOverTime()}

                        </div>)}
                        {!this.isContractor && (<div className="mb-l basicPayrun">
                            
                            <div className=" row position-absolute ">
                                <DKLabel  className="" text={`${i18next.t("BASIC_SALARY")} per payrun *`} />
                                {(isIndiaCompliance() && !Utility.isEmpty(this.basicSalaryTooltip) ) && (
                                    this.getTooltip(this.basicSalaryTooltip)
                                )}
                            </div>
                            <DKInput
                                value={this.state.employeePayrollsData['basicPayrun']}
                                title=" "
                                type="number"
                                canValidate={true}
                                errorMessage={this.basicPayrunErrorMessage}
                                validator={(value)=>{
                                    if(isIndiaCompliance() && this.basicSalaryTooltip ) {
                                        return false
                                    } else {
                                        return !this.isInValidBasic 
                                    }
                                }}
                                onChange={(value) => { this.onBasicPayChanged(value) }}
                                direction={INPUT_VIEW_DIRECTION.VERTICAL}
                                
                                  required="false"
                            />
                            {/* {(this.isInValidBasic && this.state.employeePayrollsData['basicPayrun'].trim()!='' )&& this.errorMsg(`Basic can be maximum of ${IN_COMPONENT_MAX_LIMIT.basic}% of CTC`)} */}
                        </div>)}
                        {!this.isContractor && (<div className="mb-l">
                            <PaymentMethod
                            ref={this.child} 
                            data={this.state.employeePayrollsData}
                            fieldOnly={true}
                            store={Store}
                            onPaymentMethodSelection={(data) => this.onPaymentMethodChange(data)}
                            />
                            
                        </div>)}
                        {this.isContractor && this.isContractorPayFixed && (<div className="mb-l basicPayrun">
                            <DKInput
                                value={this.state.employeePayrollsData['basicPayrun']}
                                title="Fixed Amount"
                                type="number"
                                canValidate={true}
                                onChange={(value) => { this.onFixedAmountChange(value) }}
                                direction={INPUT_VIEW_DIRECTION.VERTICAL}

                            />
                            {(this.isInValidBasic && this.state.employeePayrollsData['basicPayrun'].trim()!='' )&& this.errorMsg(`Basic can be maximum of ${IN_COMPONENT_MAX_LIMIT.basic}% of CTC`)}
                        </div>)}
                        {this.isContractor && !this.isContractorPayFixed &&(<div className="mb-l hoursWorked">
                            <DKInput
                                value={this.state.employeePayrollsData['hoursWorked']}
                                title="Number of Hours"
                                type="number"
                                canValidate={true}
                                onChange={(value) => { this.onRegularWorkingHoursChange(value) }}
                                direction={INPUT_VIEW_DIRECTION.VERTICAL}

                            />
                            {(this.isInValidBasic && this.state.employeePayrollsData['basicPayrun'].trim()!='' )&& this.errorMsg(`Basic can be maximum of ${IN_COMPONENT_MAX_LIMIT.basic}% of CTC`)}
                        </div>)}

                        <ShowProcessData
                            data={this.getComponentObj()}
                            userDetails={this.userDetails}
                            title="Earnings and Deductions"
                            onButtonAction={(index) => {
                                this.deleteComponent(index);
                            }}
                            onAddButton={(event, type) => {
                                this.onAddButtonClick(event, type);
                            }}
                            icon={DKIcons.ic_delete}
                            isContractor={this.isContractor}
                        />

                        {!this.isContractor && isBenefitEnabled() && <ShowProcessData
                            data={this.getBenefitObj()}
                            title="Benefits"
                            onButtonAction={(index) => {
                                this.deleteBenefit(index);
                            }}
                            onAddButton={(event, type) => {
                                this.onAddButtonClick(event, type);
                            }}
                            icon={DKIcons.ic_delete}
                            isContractor={this.isContractor}
                        />}

                        {!this.isContractor && this.isUSCompliance && this.taxContribution && this.getTaxContribution()}
                    </div>
                </Popup>
                {this.state.isAddComponentPayroll && (
                    <div className="transparent-background">

                        <div className="popup-window" style={{ width: "320px",overflow:"visible" }}>
                            <DKLabel text="Add Earnings and Deductions" className=" fs-r text-align-left fs-m fw-m mb-s width-80" />
                            <div id="component" className="parent-width mb-l" >
                                <div className="parent-width">
                                    <InputLabel text={'Earnings and Deductions'} />
                                    <Select id="compoList"
                                        options={this.componentDropDown['options']}
                                        className="menu-outer-top"
                                        placeholder="Select Earnings and Deductions"
                                        isSearchable={true}
                                        isOptionDisabled={(option) => (this.componentDropDown['isdisabled'])}
                                        defaultValue={this.componentDropDown['defaultValue']}
                                        onChange={this.onChangeOfComponent}
                                    />

                                    <div className="mt-5"></div>
                                </div>
                            </div>
                            <div id="compAmount" className="mb-l parent-width" >

                                <DKInput
                                    value={this.componentAmount }
                                    title="Amount"
                                    type="number"
                                    canValidate={true}
                                    required={this.addedComponent.type != 'EARNING'}
                                    validator={ (value)=>{
                                         return this.isValidAmount(value)
                                        }
                                    }
                                    readOnly={this.addedComponent.compObj['isVariable'] || this.addedComponent.compObj['isFormula']}
                                    onChange={(val) => { this.onCompountAmountAdded(val) }}
                                    direction={INPUT_VIEW_DIRECTION.VERTICAL}

                                />

                            </div>

                            <div id="addComponent" className="d-flex mt-l align-self-end">
                                <DKButton
                                    title="Cancel"
                                    className="bg-gray1 border-m"
                                    onClick={(event) => {
                                        this.onCancel();
                                    }}
                                />
                                <DKButton
                                    title="Add Earnings and Deductions"
                                    className={`border-m ml-r text-white ${this.isValidAmountForNewComponent ? "bg-app " :"bg-gray cursor-auto"}`}
                                    disabled={!this.isValidAmountForNewComponent}
                                    onClick={(event) => {
                                        this.onAddComponent(event);
                                    }}
                                />

                            </div>
                        </div>
                    </div>
                )}
                {this.state.isAddBenefitsPayroll && (
                    <div className="transparent-background">

                        <div className="popup-window" style={{ width: "320px",overflow:"visible" }}>
                            <DKLabel text="Add Benefit" className=" fs-r text-align-left fs-m fw-m mb-s width-80" />
                            <div id="benefit" className="parent-width mb-l" >
                                <div className="parent-width">
                                    <InputLabel text={'Benefits'} />
                                    <Select id="benefitList"
                                        options={this.benefitDropDown['options']}
                                        className="menu-outer-top"
                                        placeholder="Select benefits"
                                        isSearchable={true}
                                        defaultValue={this.benefitDropDown['defaultValue']}
                                        onChange={this.onBenefitSelect}
                                    />
                                    <div className="mt-5"></div>
                                </div>
                            </div>
                            <div id="employeeContri" className="mb-l parent-width" style = {{display: 'flex'}} >

                                <DKInput
                                    value={this.employeeBefitAmt}
                                    title="Employee Contribution"
                                    type="number"
                                    canValidate={true}
                                    errorMessage={this.employeeBefitAmt && this.employeeBefitAmt > 100 ? "Please enter valid percentage": "This field is required"}
                                    required={true}
                                    validator={(value)=>{
                                        if(value && value <= 100 || this.addedBenefit.benefitObj['employeeDeductionType'] === "amount"  ){
                                          this.formValidation("employeeBenefit", value)
                                          return  true
                                        } else {
                                          const index = this.invalidFiledArray.indexOf('employeeBenefit');
                                          if(index === -1) {
                                            this.invalidFiledArray.push("employeeBenefit")
                                          } 
                                          return  false
                                        }
                                    }}
                                    onChange={(val) => { this.onEmployeeContributionAmountAdded(val, "employeeBenefit") }}
                                    direction={INPUT_VIEW_DIRECTION.VERTICAL}

                                />
                                { this.addedBenefit.benefitObj['employeeDeductionType'] === "percent"  && (<span style={{marginTop: '30px', marginLeft: '-25px', zIndex:1}}>%</span>)}
                            </div>

                            <div id="employerContri" className="mb-l parent-width" style = {{display: 'flex'}}>

                                <DKInput
                                    value={this.employerBefitAmt}
                                    title="Employer Contribution"
                                    type="number"
                                    canValidate={true}
                                    required={true}
                                    errorMessage={this.employerBefitAmt && this.employerBefitAmt > 100 ? "Please enter valid percentage": "This field is required"}
                                    validator={(value)=>{
                                        if(value && value <= 100 || this.addedBenefit.benefitObj['employerDeductionType'] === "amount" ){
                                          this.formValidation("employerBenefit", value)
                                          return  true
                                        } else {
                                            const index = this.invalidFiledArray.indexOf('employerBenefit');
                                          if(index === -1) {
                                            this.invalidFiledArray.push("employerBenefit")
                                          } 
                                          return  false
                                        }
                                    }}
                                    onChange={(val) => { this.onEmployeeContributionAmountAdded(val, "employerBenefit") }}
                                    direction={INPUT_VIEW_DIRECTION.VERTICAL}
                                />
                                { this.addedBenefit.benefitObj['employerDeductionType'] === "percent"  && (<span style={{marginTop: '30px', marginLeft: '-25px', zIndex:1}}>%</span>)}

                            </div>

                            <div id="addComponent" className="d-flex mt-l align-self-end">
                                <DKButton
                                    title="Cancel"
                                    className="bg-gray1 border-m"
                                    onClick={(event) => {
                                        const fieldToRemoveValidation = ['employeeBenefit','employerBenefit']
                                        this.invalidFiledArray.forEach(field => {
                                            fieldToRemoveValidation.forEach(fr=>{
                                                const indexEmp = this.invalidFiledArray.indexOf(fr);
                                                if (indexEmp !== -1) {
                                                    this.invalidFiledArray.splice(indexEmp, 1);
                                                }
                                            })                                            
                                        })
                                        this.onCancel();
                                    }}
                                />
                                <DKButton
                                    title="Add Benefits"
                                    className="border-m ml-r bg-app text-white"
                                    onClick={(event) => {
                                        this.onAddBenefit();
                                    }}
                                />

                            </div>
                        </div>
                    </div>
                )}
            </>
        )
    }
}

export const showUpdatePayrollPopup = (
    config: { tableName: string; displayName: string; defaultValues?: any; recordId?: string; isCustomForm?: any; inputData?: any },
    onSave: () => void,
    onClose: () => void
) => {
    const id = `add-new-rec-popup-${new Date().getTime()}`;
    let div = document.createElement("div");
    div.className = "app-font";
    div.setAttribute("id", id);
    ReactDOM.render(
        <EditPayrollPopUp
            id={id}
            tableName={config.tableName}
            onSave={onSave}
            onClose={onClose}
            defaultValues={config.defaultValues}
            recordId={config.recordId}
            displayName={config.displayName}
            isCustomForm={config.isCustomForm}
            inputData={config.inputData}
        />,
        document.body.appendChild(div)
    );
};




export default EditPayrollPopUp;

